(function() {
    const elements = document.querySelectorAll('#vueVcRedesign');

    for (let i = 0; i < elements.length; i++) {
        new window.Vue({
            el: '#' + elements[i].id,
            data: {},
            methods: {
                fnSendTracking: function(sAction, sName = '') {
                    sAction = 'lp_' + sAction + '_clicked';

                    const aTrackingInfo = [
                        'trackEvent',
                        'landing_page_vc',
                        sAction,
                    ];

                    if (sName !== '') {
                        aTrackingInfo.push(sName);
                    }

                    window._paq.push(aTrackingInfo);
                },
            },
            created() {
            },
            mounted() {
            },
            destroy() {
            },
        });
    }
})();
